import { Box, Typography } from "@mui/material";
import { Column } from "../interface";
import { useMemo } from "react";

type BoardColumnHeadProps = {
  column: Column;
  total: number;
};

export function BoardColumnHead({
  column: { name, description },
  total,
}: BoardColumnHeadProps) {
  const regex = useMemo(() => /\((.*?)\)/, []);

  const title = useMemo(() => {
    const match = name.match(regex);
    return match ? name.replace(match[0], "") : name;
  }, [name, regex]);

  const subTitle = useMemo(() => {
    return name.match(regex)?.[1];
  }, [name, regex]);

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        component="div"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
          alignItems: "start",
          height: "40px",
          gap: 1.5,
        }}
      >
        <Box>
          <Typography variant="h5">{title}</Typography>
          {subTitle && (
            <Typography variant="subtitle1" color="text.secondary">
              ({subTitle})
            </Typography>
          )}
          {description && (
              <Typography variant="subtitle1" color="text.secondary">
                  {description}
              </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
            flexShrink: 1,
          }}
        >
          <Box
            sx={{
              backgroundColor: "secondary.light",
              color: "secondary.main",
              width: 24,
              height: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
            }}
          >
            <Typography variant="subtitle2">{total}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
